import React, { useState } from 'react';
import './App.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SplashScreen from './Components/SplashScreen-Components/SplashScreen';
import Login from './Components/Login-Components/Login';
import Signup from './Components/SignUp-Components/Signup';
import GetStarted from './Components/GetStarted-Components/GetStarted';
import Dashboard from './Components/Dashboard-Components/Dashboard';
import PracticeExam from './Components/Dashboard-Components/Practice-exam';
import AdminLogin from './Components/Admin-LoginPage/AdminLogin';
import TermsPage from './Components/Dashboard-Components/TermsPage';
import PrivacyPolicy from './Components/Dashboard-Components/PrivacyPolicy';
import ResultPage from './Components/Dashboard-Components/ResultPage';
import AdminDashboard from './Components/Admin-Dashboard-Component/AdminDashboard'
import NotificationsPage from './Components/Admin-Dashboard-Component/AdminNotifications';
import ManageStudentsSection from './Components/Admin-Dashboard-Component/ManageStudentSection';
import ExamListPage from './Components/Admin-Dashboard-Component/ExamListPage';
import AdminVouchers from './Components/Admin-Dashboard-Component/AdminVouchers';
import StudentSettings from './Components/Dashboard-Components/StudentSetting';
import MyTests from './Components/Dashboard-Components/MyTests';
import TestReport from './Components/Dashboard-Components/TestReports';
import Footer from './Components/Dashboard-Components/Footer';
import StudentNotifications from './Components/Dashboard-Components/StudentNotifications';
// import AnimatedLoginPage from './Components/Login-Components/AnimatedLoginPage';
import AdminActiveStudents from './Components/Admin-Dashboard-Component/StudentList/ActiveStudentList';
import AdminInactiveStudents from './Components/Admin-Dashboard-Component/StudentList/InactiveStudentList';
import AdminExamsManage from './Components/Admin-Dashboard-Component/ExamList/ManageExams';
import StudentList from './Components/Admin-Dashboard-Component/StudentList/StudentList';
import SubjectList from './Components/Admin-Dashboard-Component/SubjectList/SubjectList';
import TopicList from './Components/Admin-Dashboard-Component/TopicList/TopicList';
import AdminSettingsPage from './Components/AdminSideBar-Component/AdminSettingsPage';
import QuestionList from './Components/AdminSideBar-Component/QuestionList';
import QuestionsSetPage from './Components/AdminSideBar-Component/QuestionsSetPage';
import StudentLogin from './Components/Login-Components/StudentLogin';
import ManageQuestionSets from './Components/AdminSideBar-Component/ManageQuestionSets';
import ActiveVouchers from './Components/Admin-Dashboard-Component/VouchersList/ActiveVouchersList';
import InactiveVouchers from './Components/Admin-Dashboard-Component/VouchersList/InactiveVouchersList';
import PrivateRoute from './PrivateRoute';
import TestPracticeSetsStart from './Components/Dashboard-Components/PracticeSets/TestPracticeSetStart';
import InactiveVouchersPage from './Components/Dashboard-Components/StudentVoucherComponent/InactiveVouchersPage';
import PracticeResultPage from './Components/Dashboard-Components/PracticeResultPage';
import ManageInstances from './Components/AdminSideBar-Component/ManageInstances';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleSplashFinish = () => {
    setIsLoading(false);
  };

  return (
    <div className='app-wrapper'>
      <BrowserRouter>
        {isLoading ? (
          <SplashScreen onFinish={handleSplashFinish} />
        ) : (
          <>
            <div div className='app-content'>

              <Routes>
                {/* <Route path="/login" element={<Login />} /> */}
                {/* <Route path='/Animated-LoginPage' element={<AnimatedLoginPage />} /> */}

                <Route path="/" element={<StudentLogin />} />
                <Route path="/admin-login" element={<AdminLogin />} />
                <Route path='/admin-dashboard' element={<AdminDashboard />}></Route>
                <Route path="/signup" element={<Signup />} />
                {/* <Route path="/get-started" element={<GetStarted />} /> */}
                {/* <Route
                  path="/get-started"
                  element={
                    <PrivateRoute>
                      <GetStarted />
                    </PrivateRoute>
                  }
                /> */}
                <Route
  path="/get-started"
  element={
    <PrivateRoute userType="student">
      <GetStarted />
    </PrivateRoute>
  }
/>


                {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                {/* <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                /> */}
                <Route
  path="/dashboard"
  element={
    <PrivateRoute userType="student">
      <Dashboard />
    </PrivateRoute>
  }
/>
                <Route path="/practice" element={<PracticeExam />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/settings" element={<StudentSettings />} />
                {/* <Route path="/result" element={<ResultPage />} /> */}
                <Route path="/result/:resultId" element={<ResultPage />} />
                <Route path="/admin-notifications" element={<NotificationsPage />} />
                <Route path="/manage-students" element={<ManageStudentsSection />} />
                <Route path="/exams" element={<ExamListPage />} />
                <Route path="/admin-vouchers" element={<AdminVouchers />} />
                <Route path="/my-tests" element={<MyTests />} />
                <Route path="/test-report" element={<TestReport />} />
                <Route path="/student-notifications" element={<StudentNotifications />} />
                <Route path="/admin/active-students" element={<AdminActiveStudents />} />
                <Route path="/students-list" element={<StudentList />} />
                <Route path="/admin/inactive-students" element={<AdminInactiveStudents />} />
                <Route path="/admin/active-vouchers" element={<ActiveVouchers />} />
                <Route path="/admin/inactive-vouchers" element={<InactiveVouchers />} />

                <Route path="/admin/exams" element={<AdminExamsManage />} />
                <Route path="/admin/subjects" element={<SubjectList />} />
                <Route path="/admin/topics" element={<TopicList />} />
                <Route path="/admin/questions" element={<QuestionList />} />
                <Route path="/admin/questions-set" element={<QuestionsSetPage />} />
                <Route path="/admin/manage-question-sets" element={<ManageQuestionSets />} />
                <Route path="/admin/settings" element={<AdminSettingsPage />} />
                <Route path="*" element={<Login />} />
               <Route path="/test-practice/:practiceSetId" element={<TestPracticeSetsStart />} />
<Route path="/inactive-vouchers" element={<InactiveVouchersPage />} />
<Route path="/practice-result" element={<PracticeResultPage />} />
 <Route path="/admin/manage-instances" element={<ManageInstances />} />
              </Routes>
            </div>
            <Footer />
          </>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;